import React, { createContext, useState, useEffect } from 'react';

import api from '../services/api';

const AuthContext = createContext({
    signed: false, 
    user: {
        id: '',
        name: '',
        email: '',
    }
});

export const AuthProvider = ({ children }) => {
    
    const [user, setUser] = useState(localStorage.getItem('user'));
    
    useEffect(() => {
        async function loadStorageData() {
            const storageUser = localStorage.getItem('user');

            if (storageUser) {
                setUser(JSON.parse(storageUser));
            }
        }

        loadStorageData();
    }, [])

    async function signIn(email) {

        const response = await api.post('/login', {
            email
        });
        const { data } = response.data;

        if(data.user) {
            setUser(data.user);
      
            localStorage.setItem('user', JSON.stringify(data.user));
        }
        return data;

    }

    function signOut() {
        localStorage.removeItem("user");
        setUser(null);
    }

    return (
        <AuthContext.Provider value={{ signed: !! user, user, signIn, signOut }} >
            {children}
        </AuthContext.Provider>
    )
}

export default AuthContext;
